import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';

// For Firebase JS SDK v7.20.0 and later, measurementId is optional

const firebaseConfig = {
    apiKey: "AIzaSyDt2pjQzK6Lzf5DBUfItXkFNov5xCOrmmM",
    authDomain: "fir-d0fad.firebaseapp.com",
    projectId: "fir-d0fad",
    storageBucket: "fir-d0fad.appspot.com",
    messagingSenderId: "466573867570",
    appId: "1:466573867570:web:22fff2c0beee0f0c401a2b",
    measurementId: "G-6LG37G7VR7"
  };
  const firebaseApp = firebase.initializeApp(firebaseConfig);
const db= firebaseApp.firestore();
const auth = firebase.auth();
 export { db,auth}